import { Panel } from "../trade_review/trade_review_parts"

const SECTIONS: { title: string; points: string[] }[] = [
  {
    title: "KeHE",
    points: [
      "Each Promomash promotion through KeHE is laid on KeHE's weekly shipments to that retailer, item by item. Shipments are sell-in to the retailer's warehouse or stores, not register sales.",
      "The event is the promo weeks plus the two weeks before and the week after, because warehouse chains buy in early. Its baseline is the clean weeks up to ten weeks either side; any week another promo touches, and any load-in spike, is left out.",
      "A promo is read only when its baseline is steady: less than 40% apart before and after, and steady week to week, unless the response is far larger than the noise.",
      "Items in their first eight weeks of shipping are left out, so a new item's load-in is not counted as lift.",
      "The model check fits every retailer, item and week at once, with buy-in and trailing weeks of their own.",
      "Planned lift is Promomash's planned lift on the promotion's lines, weighted by planned base volume.",
    ],
  },
  {
    title: "Kroger",
    points: [
      "Kroger bills the EDLP scan on every unit sold over long periods. That gives sales per day per division and item. A deal billed inside the same period gives its own units per day. Lift is the deal's units a day against the rest of the period's.",
      "Reversals and rebills are netted. A line that sits on two deductions is counted once.",
      "Cost per extra unit is the deal's scan money divided by its extra units.",
    ],
  },
  {
    title: "Matched spend",
    points: [
      "Matches come from the Promomash clearing and deduction-invoice imports, the JC chargebacks import, BigWiz and rules on Kroger rates and dates. A deduction matched to several promotions is split evenly between them.",
      "Extra sales are valued at Saffron Road's invoice price to KeHE.",
    ],
  },
]

export function MethodTab() {
  return (
    <Panel title="How we measured">
      <div class="space-y-4">
        {SECTIONS.map((section: { title: string; points: string[] }) => (
          <div key={section.title} class="space-y-1.5">
            <h3 class="text-sm font-medium">{section.title}</h3>
            <ul class="list-disc pl-5 space-y-1 text-sm max-w-3xl">
              {section.points.map((point: string) => <li key={point}>{point}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </Panel>
  )
}
